import React from 'react';
import PageShell from '../../components/PageShell';
import { Eyebrow, CTABanner } from '../../components/common/Primitives';
import LicenceFeeHighlight from '../../components/common/LicenceFeeHighlight';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { FAQ_ITEMS } from '../../lib/mock';

export default function FAQ() {
  return (
    <PageShell>
      <section className="px-6 pt-12 pb-8">
        <div className="mx-auto max-w-[1240px]">
          <h1 className="text-[42px] md:text-[52px] font-extrabold leading-[1.06] tracking-tight text-navy">Frequently asked questions</h1>
          <p className="mt-5 max-w-2xl text-[15.5px] leading-relaxed text-ink-500">Clear answers about curriculum, access, hardware, classroom use, analytics and deployment.</p>
          <div className="mt-6"><LicenceFeeHighlight /></div>
        </div>
      </section>

      <section className="px-6 py-8">
        <div className="mx-auto max-w-[900px]">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ_ITEMS.map((f,i)=>(
              <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl border border-canvas-200 bg-white shadow-soft data-[state=open]:shadow-card">
                <AccordionTrigger className="px-5 py-4 text-left text-[15px] font-semibold text-navy hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="px-5 pb-4 text-[13.5px] text-ink-500">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section className="px-6 pb-24 pt-8">
        <div className="mx-auto max-w-[900px]">
          <CTABanner title="Ready to bring Gyan Dhara to your institution?" desc="Request a demo or begin a deployment discussion." primary={{ label: 'Start Deployment', to: '/start-deployment' }} secondary={{ label: 'Request Demo', to: '/request-demo' }} />
        </div>
      </section>
    </PageShell>
  );
}
